import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
import DesignerTextField from './DesignerTextField';

import { androidBackButton } from './Utils';

class ForgotPassword extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      email: '',
    };
  }
  componentDidMount() {
    androidBackButton(this.handleGoBackRoom);
  }

  handleGoBackRoom = () => {
    this.props.navigate(`/Login`);
  };

  handleSendEmail = () => {
    //sends an email to the user to retrieve the password
    this.props.navigate(`/Verification`);
  };

  handleEmailInput = (event) => {
    this.setState({ email: event.target.value });
  };

  render() {
    return (
      <div className="ForgotPasswordHome">
        <h1 className="ForgotPasswordH1">Forgot Password</h1>

        <div className="arrowBackButtonDiv_CG">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBackRoom}></DesignerButton>
        </div>

        <label className="explanationText">
          Enter your email address and we will send you a verification code to
          reset your password.
        </label>

        <label className="EmailLabel">Email Address</label>

        <DesignerTextField
          style={{ position: 'absolute', top: '280px' }}
          value={this.state.email}
          onChange={this.handleEmailInput}
          minlength={4}
          placeholder={'Email Address'}></DesignerTextField>

        <div
          className="createButtonOuterDiv"
          style={{ position: 'absolute', bottom: '15px' }}>
          <div className="createButtonInnerDiv">
            <DesignerButton
              class="filledButton"
              disabled={this.state.email.length < 10 ? true : false}
              onClick={this.handleSendEmail}
              buttonText="Send"></DesignerButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withCookies(ForgotPassword);
